import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import H3 from '@base/H3/H3';
import H2 from '@base/H2/H2';
import { getImage } from '@utils/imageHelper';

const cards = [
  {
    img: getImage('classroom/create-class.png'),
    label: 'Create a new class',
    msg: "As a teacher, one of the first things you'll do in Classroom is create a class for each of the classes you teach."
  },
  {
    img: getImage('classroom/invite-students.png'),
    label: 'Invite your students',
    msg: 'To enroll students in your class, you need to invite them or give them a code to join.'
  },
  {
    img: getImage('classroom/teach-live.png'),
    label: 'Start teaching live',
    msg: 'Your content is your greatest asset. Take it to the next level with Unacademy’s top-notch live classroom experience.'
  }
];

const Image = styled.div`
  width: 336px;
  height: 252px;
  background-image: url(${({ img }) => img});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
`;

const Label = styled(H3)`
  padding-top: 32px;
  padding-bottom: 16px;
  color: var(--color-i-black);
`;

const Message = styled.p`
  font-size: 16px;
  line-height: 150%;
  color: var(--color-i-black);
`;

const CardWrapper = styled.div`
  width: 336px;
`;

const CardsWrapper = styled.section`
  display: flex;
  grid-column: span 24;
  justify-content: space-between;
  margin-top: 56px;
`;

const StyledH2 = styled(H2)`
  margin-top: 120px;
  text-align: center;
`;

const Card = ({ card }) => {
  const { img, label, msg } = card;
  return (
    <CardWrapper>
      <Image img={img} alt={label} />
      <Label>{label}</Label>
      <Message>{msg}</Message>
    </CardWrapper>
  );
};

const SecondSlide = () => {
  return (
    <>
      <StyledH2>Start teaching in three simple steps</StyledH2>

      <CardsWrapper>
        {cards.map((card) => (
          <Card key={card.label} card={card} />
        ))}
      </CardsWrapper>
    </>
  );
};

export default SecondSlide;

Card.propTypes = {
  card: PropTypes.objectOf(PropTypes.any).isRequired
};
